{
  "name": "scw-digital-boards",
  "version": "2.15.0",
  "scripts": {
    "ng": "ng",
    "lint": "eslint src/app/pages/dashboard-content/widget-add-edit-dialog/widget-add-edit-dialog.component.ts src/app/pages/dashboard-content/dashboard-constants.class.ts --force",
    "start": "ng serve --configuration=local",
    "clean-start": "sudo rm -rf node_modules && sudo rm -rf .angular && sudo rm -rf dist && sudo npm i --legacy-peer-deps && sudo npm run start",
    "unpack:widgets": "rm -rf node_modules/scw-digital-boards-widgets && npm i scw-digital-boards-widgets --legacy-peer-deps",
    "build": "npm run unpack:widgets && ng build",
    "watch": "ng build --watch",
    "test": "ng test --browsers ChromeHeadless"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^20.3.34",
    "@angular/animations": "^20.3.28",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.28",
    "@angular/compiler": "^20.3.28",
    "@angular/core": "^20.3.28",
    "@angular/forms": "^20.3.28",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.28",
    "@angular/platform-browser-dynamic": "^20.3.28",
    "@angular/router": "^20.3.28",
    "@angular/service-worker": "^20.3.28",
    "@formio/angular": "^9.0.0-rc.3",
    "@formio/js": "^5.1.1",
    "@microsoft/applicationinsights-web": "^3.3.5",
    "@microsoft/signalr": "5.0.17",
    "@ngrx/component-store": "^20.1.0",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "angular2-multiselect-dropdown-ivy": "^1.0.4",
    "d3": "6.0.0",
    "dayjs": "^1.11.13",
    "decimal.js": "^10.6.0",
    "echarts": "^5.6.0",
    "gridstack": "^12.2.1",
    "iframe-resizer": "4.2.11",
    "lodash": "^4.17.21",
    "moment-timezone": "^0.5.47",
    "mustache": "^4.2.0",
    "ngx-daterangepicker-material": "^6.0.4",
    "ngx-echarts": "^19.0.0",
    "ngx-editor": "^18.0.0",
    "rxjs": "~7.8.0",
    "scw-digital-boards-widgets": "file:scw-digital-boards-widgets-2.15.0.tgz",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/build": "^20.3.34",
    "@angular/cli": "^20.3.34",
    "@angular/compiler-cli": "^20.3.28",
    "@angular/language-service": "^20.3.28",
    "@angular/localize": "^20.3.28",
    "@eslint/compat": "^1.2.7",
    "@eslint/eslintrc": "^3.3.0",
    "@eslint/js": "^9.21.0",
    "@stylistic/eslint-plugin": "^4.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.15",
    "@types/mustache": "^4.2.5",
    "@typescript-eslint/eslint-plugin": "^8.24.1",
    "@typescript-eslint/parser": "^8.24.1",
    "eslint": "^9.20.1",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-sonarjs": "^3.0.2",
    "globals": "^16.0.0",
    "jasmine-core": "^5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.5.1",
    "prettier-plugin-organize-imports": "^4.1.0",
    "typescript": "~5.9.3"
  }
}
